var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"embed-audience-app",attrs:{"src":_vm.audienceAppUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }